import CardList from './CardList';

export default {
    list: CardList,
};
